// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-contact-jsx": () => import("./../../../src/pages/contact.jsx" /* webpackChunkName: "component---src-pages-contact-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-members-jsx": () => import("./../../../src/pages/members/[...].jsx" /* webpackChunkName: "component---src-pages-members-jsx" */),
  "component---src-pages-strapi-pages-url-jsx": () => import("./../../../src/pages/{strapiPages.url}.jsx" /* webpackChunkName: "component---src-pages-strapi-pages-url-jsx" */),
  "component---src-pages-team-jsx": () => import("./../../../src/pages/team.jsx" /* webpackChunkName: "component---src-pages-team-jsx" */)
}

